import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { LanguageProvider } from "@/lib/LanguageContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Doctors from "@/components/Doctors";
import News from "@/components/News";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import SeoManager from "@/components/SeoManager";
import ScrollToTop from "@/components/ScrollToTop";
import LaporanIndex from "@/pages/LaporanIndex";
import LaporanDetail from "@/pages/LaporanDetail";
import { AnalisisIndex, AnalisisDetail, SiperkasaIndex } from "@/pages/AnalisisPages";
import StrukturOrganisasi from "@/pages/StrukturOrganisasi";
import Sejarah from "@/pages/Sejarah";
import NewsDetail from "@/pages/NewsDetail";
import MaintenanceGate from "@/components/MaintenanceGate";
import SplashScreen from "@/components/SplashScreen";
import { AuthProvider } from "@/admin/AuthContext";
import AdminLogin from "@/admin/AdminLogin";
import ForgotPassword from "@/admin/ForgotPassword";
import ResetPassword from "@/admin/ResetPassword";
import AdminDashboard from "@/admin/AdminDashboard";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

const RedirectAnalisis = () => {
  const { sub } = useParams();
  return <Navigate to={`/siperkasa/${sub}`} replace />;
};

const PublicSite = () => (
  <div className="App font-body" data-testid="app-root">
    <SeoManager />
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <Doctors />
      <News />
      <Gallery />
      <Contact />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            {/* Admin routes bypass maintenance mode — superadmin must be able to disable it */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
            {/* Public routes wrapped in MaintenanceGate */}
            <Route
              path="/*"
              element={
                <MaintenanceGate>
                  <>
                    <SplashScreen />
                    <Routes>
                      <Route path="/laporan" element={<LaporanIndex />} />
                      {/* SIPERKASA (formerly under /laporan/analisis) */}
                      <Route path="/siperkasa" element={<SiperkasaIndex />} />
                      <Route path="/siperkasa/:sub" element={<AnalisisDetail />} />
                      {/* Redirect old analisis URLs → SIPERKASA */}
                      <Route path="/laporan/analisis" element={<Navigate to="/siperkasa" replace />} />
                      <Route path="/laporan/analisis/:sub" element={<RedirectAnalisis />} />
                      <Route path="/laporan/:category" element={<LaporanDetail />} />
                      <Route path="/profil/struktur-organisasi" element={<StrukturOrganisasi />} />
                      <Route path="/profil/sejarah" element={<Sejarah />} />
                      <Route path="/berita/:id" element={<NewsDetail />} />
                      <Route path="/*" element={<PublicSite />} />
                    </Routes>
                  </>
                </MaintenanceGate>
              }
            />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
